export const unitFaq = {
  head: {
    title: "Domande e risposte dell'unità",
    chip: "AI",
    subPre: "Risposte specifiche per",
    subStrong: "questa unità",
    subPost: ". L'agente le userà per prime quando aiuta un ospite che soggiorna qui (es. il codice della porta, le particolarità di questo appartamento…). Allega immagini o video e l'agente li invierà ogni volta che l'ospite ne avrà bisogno.",
  },
  clone: {
    titleNoun: "FAQ",
    itemNoun: "le FAQ",
    buttonLabel: "Clona domande",
  },

  copyOne: {
    title: "Copia questa domanda",
    itemNoun: "domanda",
  },
  loading: "Caricamento…",
  emptyList: "Ancora nessuna domanda. Aggiungi la prima così l'agente saprà come rispondere.",
  list: {
    newQuestion: "Nuova domanda",
    attachments: "{count} allegato | {count} allegati",
    learnedTitle: "Aggiunta tramite auto-apprendimento",
    deleteTitle: "Elimina",
    copyTitle: "Copia in altre unità",
  },
  form: {
    questionLabel: "Domanda",
    answerLabel: "Risposta dell'agente",
    qPlaceholder: "Domanda · es. Qual è il codice della porta?",
    aPlaceholder: "Risposta · es. Il codice d'ingresso del tuo edificio è 4512.",
    removeAttachment: "Rimuovi allegato",
    uploading: "Caricamento…",
    attach: "Allega",
    addQuestion: "Aggiungi domanda",
  },
  preview: {
    tag: "Anteprima · WhatsApp",
    online: "online",
    aiReception: "Reception AI",
    questionPlaceholder: "Scrivi la domanda dell'ospite…",
    answerPlaceholder: "Scrivi la risposta che darà l'agente…",
    videoFile: "Video",
    genericFile: "File",
    empty: "Seleziona o crea una domanda per vedere come risponderà l'agente.",
    hint: "Ecco come lo vedrà l'ospite nella sua chat",
  },
  footer: {
    saved: "Salvato",
    save: "Salva modifiche",
  },
  errors: {
    load: "Impossibile caricare le domande.",
    attachNeedsQA: "Scrivi la domanda e la risposta prima di allegare file.",
    attachNeedsSave: "Salva prima per poter allegare file.",
    upload: "Impossibile caricare il file.",
    deleteFile: "Impossibile eliminare il file.",
    save: "Impossibile salvare.",
  },
};
